var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 153,
    viewBox: "0 0 217 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Libre Blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 24",
    filter: "url(#filter0_i_18_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.98 105.01C100.844 97.8342 11.8394 85.4343 2.52431 115.116C2.96567 130.165 4.03363 138.347 14.2188 150.357H212.98V148.694L214.36 147.032L212.98 140.383L214.36 138.056L212.98 129.412V124.425L214.36 121.765L212.98 112.224L214.015 109.464L212.98 105.01Z",
    fill: "url(#paint0_linear_18_81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22",
    d: "M217 102.396C143.525 99.2357 12 98 8.87277 102.396C-6.16289 111.598 -0.148621 144.008 12.515 152.633H18.5624C14.5529 150.022 -14.8502 102.396 26.5814 105.586C42.9052 106.842 136.253 104.607 217 105.586V102.396Z",
    fill: "#00813A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    width: 200.475,
    height: 2.67301,
    transform: "matrix(-1 0 0 1 217 149.959)",
    fill: "#00813A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M213.659 146.952C213.391 146.685 37.5744 148.957 22.8729 145.95",
    stroke: "url(#paint1_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M213.325 139.602C213.057 139.334 45.5936 142.609 30.8921 139.602",
    stroke: "url(#paint2_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M213.325 122.895C213.057 122.628 90.3665 125.903 75.6649 122.895",
    stroke: "url(#paint3_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M213.325 110.549C213.057 110.281 138.815 113.556 124.113 110.549",
    stroke: "url(#paint4_linear_18_81)",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Libre Blue_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 24_2",
    filter: "url(#filter1_i_18_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5482 53.996C121.146 46.7838 207.344 34.3217 216.365 64.1522L210.351 99.5695L12.5482 99.5695V97.899L11.2117 96.2283L12.5482 89.5458L11.2117 87.2069L12.5482 78.5197V73.5078L11.2117 70.8348L12.5482 61.246L11.5458 58.4721L12.5482 53.996Z",
    fill: "url(#paint5_linear_18_81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cape_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22_2",
    d: "M8.27197 50.6803C85.0722 51.7782 184.08 43.2083 212.733 50.3429C223.173 50.3429 209.633 85.9659 213 102H208C204.203 86.6368 220.565 63.478 209 56.1443C205.993 49.975 89.0192 52.891 8.27197 53.87V50.6803Z",
    fill: "#006793"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23_2",
    d: "M8.5387 98.9012H209.014V102L8.5387 101.574V98.9012Z",
    fill: "#006793"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2_2",
    d: "M11.8799 95.8941C12.1472 95.6268 187.964 97.8989 202.666 94.8917",
    stroke: "url(#paint6_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3_2",
    d: "M12.214 88.5433C12.4813 88.276 179.945 91.5504 194.647 88.5433",
    stroke: "url(#paint7_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4_2",
    d: "M12.214 71.837C12.4813 71.5697 135.172 74.8441 149.874 71.837",
    stroke: "url(#paint8_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5_2",
    d: "M12.214 59.4902C12.4813 59.2229 86.724 62.4973 101.426 59.4902",
    stroke: "url(#paint9_linear_18_81)",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Libre Red"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 24_3",
    filter: "url(#filter2_i_18_81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7981 3.40881C128.168 -4.25315 195.228 3.09551 204.812 34.7861L210.491 48.2745L13.5 50.5L12.7981 50.0493L11.3783 48.2745L12.7981 41.1753L11.3783 38.6906L12.7981 29.4616V24.1372L11.3783 21.2976L12.7981 11.1108L11.7333 8.16403L12.7981 3.40881Z",
    fill: "url(#paint10_linear_18_81)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cape_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22_3",
    d: "M8.53857 0.550255C111.153 2.01716 199.638 -12.9511 213.023 50.7871H208.5C193.765 -8.83574 117.314 2.42111 8.53857 3.7399V0.550255Z",
    fill: "#AA0000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23_3",
    x: 8.53857,
    y: 48.114,
    width: 200.475,
    height: 2.67301,
    fill: "#AA0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2_3",
    d: "M11.5458 45.7754C11.8131 45.5081 187.63 47.7801 202.332 44.7729",
    stroke: "url(#paint11_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3_3",
    d: "M11.8799 38.4245C12.1472 38.1572 179.611 41.4317 194.313 38.4245",
    stroke: "url(#paint12_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 4_3",
    d: "M11.8799 21.7182C12.1472 21.4509 134.838 24.7254 149.54 21.7182",
    stroke: "url(#paint13_linear_18_81)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5_3",
    d: "M11.8799 9.37117C12.1472 9.10387 86.3899 12.3783 101.091 9.37117",
    stroke: "url(#paint14_linear_18_81)",
    strokeWidth: 2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18_81",
    x: 2.52429,
    y: 96.2283,
    width: 211.836,
    height: 58.1284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_81"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_18_81",
    x: 11.2117,
    y: 45.1698,
    width: 205.153,
    height: 58.3998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_81"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_18_81",
    x: 11.3783,
    y: 0.614746,
    width: 199.113,
    height: 53.8853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_81",
    x1: 212.98,
    y1: 126.465,
    x2: 8.7345,
    y2: 126.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E7474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_81",
    x1: 213.659,
    y1: 146.738,
    x2: 22.8729,
    y2: 146.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#957C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_81",
    x1: 213.325,
    y1: 138.098,
    x2: 56.9538,
    y2: 138.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_81",
    x1: 213.325,
    y1: 123.527,
    x2: 75.6649,
    y2: 123.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB9494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18_81",
    x1: 213.325,
    y1: 111.18,
    x2: 124.113,
    y2: 111.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1ADAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18_81",
    x1: 12.5482,
    y1: 75.5578,
    x2: 210.351,
    y2: 75.5578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E7474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18_81",
    x1: 11.8799,
    y1: 95.6794,
    x2: 202.666,
    y2: 95.6794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#957C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18_81",
    x1: 12.214,
    y1: 87.0397,
    x2: 168.585,
    y2: 87.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18_81",
    x1: 12.214,
    y1: 72.4687,
    x2: 149.874,
    y2: 72.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB9494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18_81",
    x1: 12.214,
    y1: 60.1219,
    x2: 101.426,
    y2: 60.1219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1ADAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_18_81",
    x1: 12.7981,
    y1: 26.3151,
    x2: 222.934,
    y2: 26.3151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E7474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_18_81",
    x1: 11.5458,
    y1: 45.5606,
    x2: 202.332,
    y2: 45.5606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#957C7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_18_81",
    x1: 11.8799,
    y1: 36.9209,
    x2: 168.251,
    y2: 36.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977F7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_18_81",
    x1: 11.8799,
    y1: 22.3499,
    x2: 149.54,
    y2: 22.3499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB9494"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_18_81",
    x1: 11.8799,
    y1: 10.0028,
    x2: 101.091,
    y2: 10.0028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1ADAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon 4.3bcc7a94381eb2b2e358159450f14e71.svg";
export { ForwardRef as ReactComponent };